import React, { useContext } from "react";
import { FaCheckCircle, FaLightbulb, FaHandsHelping, FaBullhorn } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./iso.jpg";

const ISO19011: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/iso-19011');
    } else {
      navigate('/login', { state: { from: '/booking/iso-19011' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">ISO Training</span>
          <h1 className="hero-title">ISO 19011 Auditor</h1>
          <p className="hero-subtitle">
            Ensuring effective auditing and compliance
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Introduction to ISO 19011:2018</h2>
              <p className="article-text">
                ISO 19011:2018 provides guidelines for auditing management systems. It ensures that audits are conducted effectively and consistently across various ISO standards.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Scope of the Standard</h2>
              <p className="article-text">
                The scope of ISO 19011 includes principles of auditing, managing audit programmes, and conducting audits. It applies to all organizations regardless of size or sector.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Types and Process of Audit</h2>
              <p className="article-text">
                Audits can be internal, external, or supplier audits. The process involves planning, conducting, reporting, and following up on audit findings.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Principles of Auditing</h2>
              <p className="article-text">
                The principles of auditing include integrity, fair presentation, due professional care, confidentiality, independence, and evidence-based approach.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Managing an Audit Programme</h2>
              <p className="article-text">
                Managing an audit programme involves defining objectives, allocating resources, and monitoring performance to ensure the effectiveness of audits.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Audit Objectives and Scope</h2>
              <p className="article-text">
                Audit objectives define what the audit aims to achieve, while the scope specifies the boundaries, such as processes, locations, and timeframes.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Audit Risks and Opportunities</h2>
              <p className="article-text">
                Identifying risks and opportunities during audits helps organizations improve processes and address potential issues proactively.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Audit Programme Resources</h2>
              <p className="article-text">
                Adequate resources, including skilled auditors, tools, and time, are essential for conducting effective audits and achieving desired outcomes.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Audit Activities</h2>
              <p className="article-text">
                Audit activities include preparing checklists, conducting interviews, reviewing documents, and observing processes to gather evidence.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Audit Techniques and Skills</h2>
              <p className="article-text">
                Effective audit techniques include questioning, listening, and analyzing data. Auditors must possess strong communication and problem-solving skills.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Competence and Behaviour of an Auditor</h2>
              <p className="article-text">
                Auditors must be competent in auditing techniques and knowledgeable about the standards being audited. Professional behaviour ensures credibility and trust.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Roles and Responsibilities of an Auditor</h2>
              <p className="article-text">
                Auditors are responsible for planning and conducting audits, reporting findings, and providing recommendations for improvement.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Key Elements</h4>
              <ul className="key-list">
                <li><FaCheckCircle className="check-icon" /> Integrity & Care</li>
                <li><FaLightbulb className="check-icon" /> Audit Planning</li>
                <li><FaHandsHelping className="check-icon" /> Risk Assessment</li>
                <li><FaBullhorn className="check-icon" /> Clear Reporting</li>
              </ul>
            </div>

            <div className="sidebar-widget">
              <h4 className="widget-title">Why ISO 19011?</h4>
              <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '0.9rem' }}>
                Develop auditor competence and ensure your management systems are effectively evaluated.
              </p>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Get Certified</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Start your journey towards standard compliance.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ISO19011;

